import React from 'react'
import { Box, Text } from 'theme-ui'

import Section from '../Section/index'
import { TextSectionProps } from './types'
import Wysiwyg from './../../organisms/Wysiwyg'

const TextSection: React.FC<TextSectionProps> = ({
  id,
  heading,
  isHeadingGreen,
  subheading,
  description,
  bgColor,
  inner,
  paddingTop,
  paddingBottom,
  headingPadding,
  data,
  isFullWidth
}) => {
  return (
    <Section
      {...{
        id,
        inner,
        paddingTop,
        paddingBottom,
        headingPadding,
        bgColor,
        heading,
        isHeadingGreen,
        subheading,
        description,
        data,
        isFullWidth
      }}
      body={
        <Box
          sx={{
            width: !isFullWidth ? ['100%', '', '50%'] : '100%'
          }}
        >
          {data && (
            <Box>
              {data.title && (
                <Text
                  as="h1"
                  sx={{
                    color: 'green',
                    fontWeight: '700',
                    fontFamily: 'secondary',
                    variant: 'bodyMontserrat20',
                    marginBottom: ['1.5625rem', '2.5rem']
                  }}
                >
                  {data.title}
                </Text>
              )}
              {data.content && (
                <Wysiwyg>
                  <div dangerouslySetInnerHTML={{ __html: data.content }} />
                </Wysiwyg>
              )}
            </Box>
          )}
        </Box>
      }
    />
  )
}

export default TextSection
